import React from 'react';
import { Box, Typography, Switch, Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from 'react-i18next';

import { CategoryLabels, KeyLabels, AdmLabels} from '../../Constants/GeologicalOptions.js';


const DesktopFilter = ({
                           categories,
                           selectedCategories,
                           selectedKeys,
                           admlayers,
                           selectedAdmLayers,
                           handleCategoryToggle,
                           handleKeyToggle,
                           handleAdmLayerToggle
                       }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
                {t('Feltarasok.Title')}
            </Typography>
            {/* Category checkboxes (desktop) */}
            <Box
                className="desktop-category-filter"
                sx={{ mb: 2 }}
            >
                {Object.entries(categories).map(([category, keys]) => (
                    <div key={category}>
                        <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'left', mt: 1 }}>
                            {t(`Categories.${category}`)}
                        </Typography>
                        {keys.map((key) => (
                            <div key={key}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedKeys[category] ? selectedKeys[category][key] : false}
                                            onChange={() => handleKeyToggle(category)(key)}
                                            color="primary"
                                            size="small"
                                            disabled={!selectedCategories.includes(category)}
                                        />
                                    }
                                    label={<Typography variant="body2" sx={{ color: 'text.primary' }}>{t(`Keys.${key}`)}</Typography>}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </Box>

            {/* Category switches (desktop) */}
            <Box className="desktop-category-switch" sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 1 }}>{t('Feltarasok.Layers')}</Typography>
                {Object.keys(categories).map(category => (
                    <Box key={category} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="body2" sx={{ color: 'text.primary' }}>
                            {t(`Categories.${category}`)}
                        </Typography>
                        <Switch
                            checked={selectedCategories.includes(category)}
                            onChange={() => handleCategoryToggle(category)}
                            color="primary"
                            size="small"
                        />
                    </Box>
                ))}
            </Box>

            {/* Admin layer switches (desktop) */}
            <Box className="desktop-admlayer-switch">
                <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 1 }}>{t('Feltarasok.AdminLayers')}</Typography>
                {Object.keys(admlayers).map(admlayer => (
                    <Box key={admlayer} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="body2" sx={{ color: 'text.primary' }}>
                            {t(`Adm.${admlayer}`)}
                        </Typography>
                        <Switch
                            checked={selectedAdmLayers.includes(admlayer)}
                            onChange={() => handleAdmLayerToggle(admlayer)}
                            color="primary"
                            size="small"
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default DesktopFilter;
